import { Injectable } from "@angular/core";
import { DatePipe } from '@angular/common';
@Injectable()

export class SavefileService {

  csvExport(response, name: string) {

    console.log("response");
    var file = new Blob([response], { type: 'text/csv' });
    const url = window.URL.createObjectURL(file); // <-- work with blob directly

    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var datePipe = new DatePipe('en-US');

    var today = Date.now();
    var date = datePipe.transform(today, 'yyyy-MM-dd HH:mm:ss');
    var filename = name + ' ' + date;

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // window.navigator.msSaveOrOpenBlob(file, "WorkPermit_" + model.workNo + ".pdf");
      window.navigator.msSaveOrOpenBlob(file, filename + ".csv");
      console.log("Yes");
    } else {
      a.href = url;
      a.download = filename + ".csv";
      a.click();
      console.log("NO")
    }

  }

  excelExport(response, name: string) {
    console.log("response");
    var file = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(file); // <-- work with blob directly

    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var datePipe = new DatePipe('en-US');
    var today = Date.now();
    var date = datePipe.transform(today, 'yyyy-MM-dd HH:mm:ss');
    var filename = name + ' ' + date

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // window.navigator.msSaveOrOpenBlob(file, "WorkPermit_" + model.workNo + ".pdf");
      window.navigator.msSaveOrOpenBlob(file, filename + ".xlsx");
      console.log("Yes");
    } else {
      a.href = url;
      a.download = filename;
      a.click();
      console.log("NO")
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/services/savefile.ts